import Map from "ol/Map";
import { Select } from "ol/interaction";
import Fill from "ol/style/Fill";
import Stroke from "ol/style/Stroke";
import Style from "ol/style/Style";
import { useEffect, useState } from "react";
import { PRIMARY_COLOR } from "../../styles";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import { Feature } from "ol";
import { FilterFunction } from "ol/interaction/Select";

export function useSelect(
	map: Map | null,
	selectableLayer: VectorLayer<VectorSource>,
	filter: FilterFunction,
	onSelect: (feature: Feature | null) => void,
) {
	const [select, setSelect] = useState(
		new Select({
			layers: [selectableLayer],
			filter,
			style: new Style({
				fill: new Fill({
					color: PRIMARY_COLOR + "88",
				}),
				stroke: new Stroke({
					color: PRIMARY_COLOR,
					width: 2,
				}),
			}),
		}),
	);

	useEffect(() => {
		setSelect(new Select({
			layers: [selectableLayer],
			filter,
			style: new Style({
				fill: new Fill({
					color: PRIMARY_COLOR + "88",
				}),
				stroke: new Stroke({
					color: PRIMARY_COLOR,
					width: 2,
				}),
			}),
		}))
	}, [filter]);

	useEffect(() => {
		if (!map) return () => {};

		function _onSelect() {
			const features = select.getFeatures().getArray();
			if (!features.length) {
				onSelect(null);
			} else {
				const feature = features[0];
				onSelect(feature);
			}
		}

		select.on("select", _onSelect);
		map.addInteraction(select);

		return () => {
			map.removeInteraction(select);
			select.un("select", _onSelect);
		};
	}, [map, select, onSelect]);

	return select;
}
